const zhTW = {
    // Navbar
    nav: {
        home: '首頁',
        features: '核心功能',
        download: 'App 下載',
        premium: '會員訂閱',
        faq: '常見問題',
        downloadNow: '立即下載',
    },
    // Hero
    hero: {
        title: '食光機,',
        subtitle: '你的智慧飲食管家',
        description: '食光機是一款結合 AI 視覺識別的健康追蹤應用。拍下食物，瞬間估算熱量與營養，幫你輕鬆記錄每一餐，科學管理健康目標。',
        newFeature: '全新一代 AI 識別引擎現已上線，更準、更快、更懂中國胃！',
        appStoreDownload: 'App Store 下載',
        learnMore: '了解更多',
        iosSupport: '支援 iOS 16.0 及以上版本',
        appleEcosystem: '蘋果生態整合',
        aiRecognition: 'AI 智慧識別',
    },
    // Features
    features: {
        title: '拍個照，營養全知道',
        description: '得益於前沿的 AI 視覺大模型，食光機能精準識別超過 10,000+ 種中西式菜餚。只需隨手一拍，它就能自動估算食材重量、卡路里及核心營養素，讓繁瑣的飲食記錄變得無比輕鬆。',
        photoRecognition: '拍照秒識別',
        calorieEstimation: '熱量估算',
        nutritionAnalysis: '營養分析',
        aiAdvisor: 'AI 營養顧問',
        accuracyNote: '* 識別準確率受拍攝角度與光線影響，資料僅供參考。',
    },
    // Downloads
    downloads: {
        title: '開始使用',
        mobileApp: '行動應用',
        ios: 'iOS',
        android: '安卓',
        directDownload: '直接下載 APK',
    },
    // FAQ
    faq: {
        title: '常見問題',
        subtitle: '這裡提供了一些常見問題的解答。',
        contact: '遇到無法解決的問題？隨時透過 App 內的回饋功能聯繫我們。',
        questions: [
            { question: "食光機是如何識別食物熱量的？", answer: "食光機接入了先進的 AI 視覺大模型引擎，並結合了本地優化的中國食物營養資料庫。當您拍下食物照片時，AI 會分析食物種類與份量，然後自動匹配資料庫為您計算熱量與巨量營養素。" },
            { question: "遊客模式和登入帳號有什麼區別？", answer: "遊客模式可以體驗基礎的記錄功能，但 AI 照片識別、AI 營養顧問等進階功能需要您透過 Apple ID 登入後方可無縫使用，以確保您的資料安全雲端同步。" },
            { question: "食光機的識別準嗎？", answer: "我們的 AI 引擎經過大量中西方菜品的訓練，準確率在同類產品中處於領先水平。但由於拍攝角度、光線和隱藏食材（如重油重糖的調味料）等因素，資料難免會有偏差，僅供健康參考。" },
            { question: "我的資料安全嗎？", answer: "我們極為注重用戶隱私。您的飲食記錄與照片資料均保存在由 Supabase 提供支援的安全雲端資料庫中，我們絕不會將您的個人資料出售給第三方。" },
            { question: "如何取消會員訂閱？", answer: "您可以隨時在您的 iOS 裝置的「設定」-「Apple ID」-「訂閱」中管理或取消您的食光機會員訂閱。" }
        ]
    },
    // Footer
    footer: {
        helpCenter: '幫助中心',
        sendFeedback: '發送回饋',
        contactEmail: '聯繫郵箱',
        product: '產品',
        iosDownload: 'iOS 下載',
        coreFeatures: '核心功能',
        subscription: '訂閱方案',
        support: '支援',
        faq: '常見問題',
        changelog: '更新日誌',
        contact: '聯繫我們',
        about: '關於',
        privacy: '隱私政策',
        terms: '服務條款',
        copyright: '© 2026 Andy Cao. All Rights Reserved.',
        wechat: '微信公眾號',
        xiaohongshu: '小紅書',
    },

    // Terms Page
    termsPage: {
        title: "服務條款",
        date: "最後更新日期：2026年02月22日",
        toc: "目錄",
        intro: "歡迎使用「食光機」！本《服務條款》（以下簡稱“本條款”）是您與應用開發者之間關於您下載、使用本應用的協議。",
        s1: "1. 接受條款",
        s1p1: "通過訪問或使用本應用，您即確認接受本條款。若不具備主體資格，請在法定監護人陪同下使用。",
        s1p2: "我們保留隨時修改本條款的權利。",
        s2: "2. 服務描述",
        s2p1: "「食光機」是一款健康管理工具，功能包括：",
        s2i1: "AI 食物圖像識別",
        s2i2: "用戶飲食記錄",
        s2i3: "營養數據統計",
        s2i4: "AI 營養顧問",
        s2p2: "請注意：本應用數據並非專業醫療建議，不可代替醫療診斷。",
        s3: "3. 帳號註冊與安全",
        s3p1: "使用特定功能需註冊帳號。",
        s3i1: "您需提供真實信息。",
        s3i2: "妥善保管帳號憑證。",
        s3i3: "發現異常立即通知我們。",
        s3i4: "我們不對您的保管不當負責。",
        s3p2: "我們有權暫停異常帳號。",
        s4: "4. 用戶行為規範",
        s4p1: "您同意不從事以下行為：",
        s4i1: "違反法律法規；",
        s4i2: "侵害第三方權益；",
        s4i3: "進行欺詐或發送惡意信息；",
        s4i4: "破壞應用運行；",
        s4i5: "未經授權獲取系統信息；",
        s4i6: "使用自動腳本獲取數據。",
        s4p2: "如有違反，我們有權封禁帳號。",
        s5: "5. 會員訂閱與付費",
        s5p1: "提供基礎版和 Pro 會員版。",
        s5p2: "訂閱將自動續期，除非在到期前24小時關閉。",
        s5p3: "退款由 Apple 政策管轄。",
        s6: "6. 知識產權",
        s6p1: "應用版權歸開發者所有。",
        s6i1: "不得修改或商業利用應用代碼。",
        s6i2: "上傳圖片版權屬您，但授權我們用於服務。",
        s6i3: "尊重知識產權。",
        s6i4: "我們有權刪除侵權內容。",
        s6p2: "反饋建議歸我們所有。",
        s6p3: "反饋視為非機密信息。",
        s6note: "⚠️ 我們有權移除侵權內容。",
        s7: "7. 隱私與數據保護",
        s7p1: "見《隱私政策》。重點：",
        s7i1: "數據儲存於安全雲服務。",
        s7i2: "不向第三方出售數據。",
        s7i3: "可隨時要求刪除數據。",
        s7i4: "可能收集匿名數據改善服務。",
        s7p2: "註銷帳號後數據不可恢復。",
        s8: "8. 免責聲明",
        s8p1: "不對以下情形負責：",
        s8i1: "非醫療建議。",
        s8i2: "服務中斷。",
        s8i3: "黑客導致的數據丟失。",
        s8i4: "第三方服務。",
        s8p2: "不對間接損失負責。",
        s9: "9. 條款終止",
        s9p1: "我們可隨時終止您的使用權。",
        s9p2: "責任限制條款繼續有效。",
        s10: "10. 適用法律",
        s10p1: "適用中華人民共和國法律。",
        s10p2: "爭議提交開發者所在地法院。",
        s11: "11. 聯繫我們",
        s11p1: "有問題請聯繫：",
        footer: "您同意受本條款約束。",
        back: "← 返回主頁",
    },

    // Privacy Page
    privacyPage: {
        title: "隱私政策",
        date: "最後更新日期：2026年02月22日",
        intro: "歡迎使用「食光機」！我們非常重視用戶隱私。",
        section1: "1. 收集信息",
        section1desc: "僅收集必要信息：",
        item1title: "帳戶信息：",
        item1desc: "生成唯一用戶標識。",
        item2title: "飲食與識別數據：",
        item2desc: "拍攝圖片及營養數據。",
        item3title: "設備數據：",
        item3desc: "崩潰日誌和設備型號，用於排查錯誤。",
        section2: "2. 資訊使用",
        section2desc1: "提供核心功能。",
        section2desc2: "絕不出售數據給第三方。",
        section2desc3: "部分匿名數據用於改進演算法。",
        section3: "3. 資訊存儲與安全",
        section3p1: "資料以加密方式保存在 Supabase。",
        section3p2: "傳輸過程使用 HTTPS。",
        section31: "協力廠商服務提供者",
        section31p1: "包括：",
        section31item1: "Supabase：提供數據庫。",
        section31item2: "OpenAI / Claude：用於圖像識別。",
        section31item3: "RevenueCat：管理訂閱。",
        section31p2: "皆受嚴格隱私政策保護。",
        section31p3: "若需轉移數據會提前通知。",
        section4: "4. 您的權力",
        section4item1: "訪問權：",
        section4item1desc: "可查看和修改數據。",
        section4item2: "刪除權：",
        section4item2desc: "可註銷帳戶，數據將被永久刪除。",
        section4item3: "撤回同意：",
        section4item3desc: "可隨時在系統撤銷相機權限。",
        section5: "5. 未成年人保護",
        section5desc: "未成年人請在監護人指導下使用。",
        section6: "6. 政策更新",
        section6desc: "修訂時會發出通知。",
        section7: "7. 聯繫我們",
        section7desc: "如有疑問請聯繫：",
        contactSite: "官方網站",
        footerNote: "您確認同意本隱私政策條款。",
        back: "← 返回主頁",
    },

    featuresPage: {
        title: "核心特性",
        subtitle: "探索食光機帶來的智慧健康管理體驗",
        aiRecognition: "AI 視覺識別",
        f1Title: "拍照秒識萬物，不再苦苦搜尋",
        f1Desc: "摒棄繁瑣的手動搜索。食光機搭載了先進的多模態大模型，能精準識別各類菜品。",
        f1List1: "支援超過 10,000+ 種日常菜品",
        f1List2: "瞬間預估卡路里及營養素",
        f1List3: "對「中國胃」特化訓練",
        f1List4: "支援手動微調分量",

        aiAdvisor: "AI 營養顧問",
        f2Title: "專屬你的口袋營養師",
        f2Desc: "基於歷史紀錄，提供個人化健康建議。",
        f2List1: "飲食結構分析與建議",
        f2List2: "智慧生成下餐推薦建議",
        f2List3: "隨時詢問營養問題",
        f2List4: "自然對話體驗",

        cloudSync: "數據雲同步",
        f3Title: "安全可靠的多端數據體驗",
        f3Desc: "紀錄幾秒內同步到雲端。",
        f3List1: "Apple ID 快捷安全登入",
        f3List2: "端到端加密保障隱私",
        f3List3: "多設備即時同步",
        f3List4: "支援離線瀏覽",

        premium: "Pro 會員權益",
        f4Title: "解鎖無限制的健康管理",
        f4Desc: "升級 Pro 會員，體驗無限制的食光機。",
        f4List1: "無限次 AI 食物視覺識別",
        f4List2: "無限次 AI 營養顧問對話",
        f4List3: "深度的歷史數據趨勢分析",
        f4List4: "一鍵匯出飲食報表 (CSV)",

        ctaTitle: "準備好開啟更健康的飲食生活了嗎？",
        ctaDesc: "今天就從拍下一張食物照片開始。",
        downloadBtn: "立即下載 iOS 版",
        viewPlan: "查看訂閱方案"
    },

    changelogPage: {
        title: "更新日誌",
        subtitle: "了解食光機的每次進步",
        latest: "最新版本",
        v100Date: "2026年3月1日",
        newFeatures: "新增功能",
        feature1: "接入最新 GPT-4o 視覺模型",
        feature2: "全新介面設計",
        feature3: "上線「數據匯出」功能",
        feature4: "支援繁體中文與英文切換",
        feature5: "新增 Apple ID 登入",
        improvements: "優化改進",
        improve1: "提升 App 啟動速度",
        improve2: "優化中餐熱量估算準確度",
        improve3: "重構 AI 顧問排版",
        fixes: "錯誤修復",
        fix1: "修復弱網環境下無法返回結果問題",
        fix2: "修復暗黑模式字體顏色異常",
        fix3: "修復跨時區時間錯亂",

        beta: "Beta",
        v090Date: "2026年2月10日",
        beta1: "內測發佈",
        beta2: "核心拍照識別功能",
        beta3: "本地數據存儲",
        beta4: "引入 AI 營養助手",
        knownIssues: "已知問題",
        issue1: "暫不支援雲端備份",
        issue2: "複雜餐盤可能識別不全",

        ctaTitle: "體驗最新功能",
        ctaDesc: "我們將以兩週為週期持續優化。",
        ctaButton: "前往 App Store 下載"
    },

    helpPage: {
        title: "幫助中心",
        subtitle: "遇到問題？在這裡找到答案",
        category1: "常見問題",
        category1desc: "解答使用的常見問題",
        category2: "訂閱與付款",
        category2desc: "會員訂閱和支付的問題",
        category3: "功能介紹",
        category3desc: "了解核心功能",
        category4: "更新日誌",
        category4desc: "查看版本更新",
        faqTitle: "熱門常見問題",
        q1: "如何使用 AI 食物識別？",
        a1: "打開 App，點擊相機拍攝。",
        q2: "為何識別有誤差？",
        a2: "受光線、角度影響，數據僅供參考。",
        q3: "如何切換語言？",
        a3: "點擊右上角按鈕即可切換。",
        q4: "數據會同步嗎？",
        a4: "登入 Apple ID 後會自動同步。",
        q5: "如何聯繫客服？",
        a5: "透過頁尾「發送回饋」按鈕聯繫。",
        noAnswer: "沒有找到答案？",
        contactSubtitle: "客服團隊為您服務",
        sendEmail: "發送郵件",
        xiaohongshu: "關注小紅書"
    },

    subscriptionPage: {
        title: "會員訂閱",
        subtitle: "選擇適合您的計劃，解鎖全部功能",
        free: "免費版",
        freePlan: "免費版",
        permanent: "/永久",
        freeDesc: "適合輕度使用",
        free1: "每天 4 次 AI 識別",
        free2: "每天 4 次 AI 對話",
        free3: "基礎飲食記錄",
        free4: "本地數據存儲",
        free5: "營養深度分析",
        free6: "高級數據匯出",
        free7: "個性化記憶",
        free8: "優先客服",
        freeUse: "免費使用",

        recommended: "推薦",
        mostPopular: "最受歡迎",
        monthlyPlan: "月卡會員",
        perMonth: "/月",
        monthlyDesc: "適合日常使用",
        monthly1: "無限次 AI 識別",
        monthly2: "無限次 AI 對話",
        monthly3: "完整飲食記錄",
        monthly4: "雲端數據同步",
        monthly5: "營養深度分析",
        monthly6: "數據匯出 (CSV)",
        monthly7: "個性化記憶",
        monthly8: "優先客服",
        subscribeNow: "立即訂閱",

        bestValue: "超值",
        annualPlan: "年卡會員",
        perYear: "/年",
        annualDesc: "相當於每月 ¥8.25",
        annual1: "無限次 AI 識別",
        annual2: "無限次 AI 對話",
        annual3: "完整飲食記錄",
        annual4: "雲端數據同步",
        annual5: "營養深度分析",
        annual6: "數據匯出 (CSV)",
        annual7: "個性化記憶",
        annual8: "優先客服",
        annual9: "專屬主題皮膚",

        faqTitle: "訂閱常見問題",
        q1: "如何訂閱會員？",
        a1: "點擊上方按鈕前往 App Store 下載並在應用內完成訂閱。",
        q2: "免費與付費版區別？",
        a2: "免費版有限制，付費版無限制且有高級功能。",
        q3: "如何取消訂閱？",
        a3: "在 iOS 設定中管理或取消。",
        q4: "訂閱能退款嗎？",
        a4: "由 Apple App Store 政策處理。",
        note: "💡 訂閱成功後自動續費，請在到期前24小時關閉。"
    }
};

export default zhTW;
